var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagesBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.811C0 5.31 5.383 0.835999 12 0.835999C18.617 0.835999 24 5.30899 24 10.809C24 16.309 18.617 20.784 12 20.784C10.726 20.7868 9.45731 20.6186 8.228 20.284L2.24699 23.068C1.86121 23.2477 1.40395 23.1635 1.10742 22.8582C0.810913 22.5529 0.740112 22.0934 0.931 21.713L3.05701 17.469C1.14096 15.7828 0.0299835 13.3631 0 10.811ZM8.438 18.262C9.59285 18.612 10.7933 18.7886 12 18.786C17.514 18.786 22 15.209 22 10.811C22 6.41299 17.514 2.836 12 2.836C6.48599 2.836 2 6.41101 2 10.811C2.05376 13.038 3.13335 15.1152 4.925 16.439C5.29291 16.7338 5.405 17.2454 5.194 17.667L4.325 19.402C4.2771 19.4971 4.29471 19.6122 4.36888 19.6886C4.44305 19.765 4.5575 19.786 4.65401 19.741L7.724 18.312C7.94768 18.2078 8.20198 18.19 8.438 18.262Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesBubble);
export default __webpack_public_path__ + "static/media/messagesBubble.99c53556.svg";
export { ForwardRef as ReactComponent };